import React from "react";
import { useState, useEffect } from "react";

import "../../styles/cuentaAtrasPreguntas.css";
import { estilos2 } from "../../Lib/estilosCuentaRegresiva";

export default function CuentaAtrasPista(props) {
    const { startingMinutes = 0, startingSeconds = props.temporizadorPistas } = props;
    const [mins, setMinutes] = useState(startingMinutes);
    const [secs, setSeconds] = useState(startingSeconds);
    const [tiempoFinalizado, setTiempoFinalizado] = useState("");
    const [estilosBorde, setEstilosBorde] = useState("0.5vw solid rgb(0, 50, 126)");
    useEffect(() => {
        let sampleInterval = setInterval(() => {
        if (secs > 0) {
            setSeconds(secs - 1);
            const randomValue2 = Math.floor((Math.random() * 30) + 1);
            setEstilosBorde(estilos2[randomValue2]);
        }
        if (secs === 0) {
            if (mins === 0) {
            clearInterval(sampleInterval);
            props.fTemporizadorPistas(true);

            } else {
            setMinutes(mins - 1);
            setSeconds(59);
            }
        }
        }, 1000);
        return () => {
        clearInterval(sampleInterval);
        setTiempoFinalizado("X");
        };
    });

    return (
        <div className="cuentaAtrasPregunta__div" style={{"border": `0.3vw solid ${estilosBorde}`}}>
        {(mins === 0 && secs === 0) ? (tiempoFinalizado) : (
            <p>
            {" "}
            {secs < 10 ? `0${secs}` : secs}
            </p>
        )}
        </div>
    );
}